'use client';

import { useAuth } from '@/hooks/useAuth';
import { NotificationSuccess } from '@/components';
import { makeAuthRequest } from '@/config/authApi.config';
import {
  Modal,
  ModalContent,
  ModalHeader,
  ModalBody,
  Switch,
} from '@nextui-org/react';
import { useState } from 'react';
import { useSession } from 'next-auth/react';

interface AccountSettingModalProps {
  isOpen: boolean;
  onClose: () => void;
}

const AccountSettingModal = ({ isOpen, onClose }: AccountSettingModalProps) => {
  const { session } = useAuth();
  const { update } = useSession();
  const [getNotiWhenJobOpen, setGetNotiWhenJobOpen] = useState<boolean>(
    session?.user?.getNotiWhenJobOpen || false
  );
  const [isLoading, setIsLoading] = useState(false);

  const updateUserSettings = async (newValue: boolean) => {
    setIsLoading(true);
    try {
      const res = await makeAuthRequest({
        method: 'PATCH',
        path: `/users/${session?.user?.id}`,
        body: {
          getNotiWhenJobOpen: newValue,
        },
      });

      // Cập nhật session với thông tin mới
      if (res && session) {
        await update({
          ...session,
          user: {
            ...session.user,
            getNotiWhenJobOpen: newValue,
          },
        });
      }

      if (newValue){
        NotificationSuccess('Update account successfully, you will receive a notification when a job opens');
      } else {
        NotificationSuccess('Update account successfully, you will not receive a notification when a job opens');
      }

    } catch (error) {
      console.error('Error updating user settings:', error);
    } finally {
      setIsLoading(false);
    }
  };

  const handleToggleChange = (value: boolean) => {
    setGetNotiWhenJobOpen(value);
    updateUserSettings(value);
  };

  return (
    <Modal isOpen={isOpen} onClose={onClose} placement="center">
      <ModalContent>
        <ModalHeader className="text-xl font-semibold">Account Setting</ModalHeader>
        <ModalBody>
          <div className="flex items-center justify-between py-2">
            <span>Get notified when a job opens</span>
            <Switch
              color='secondary'
              isSelected={getNotiWhenJobOpen}
              onValueChange={handleToggleChange}
              isDisabled={isLoading}
            />
          </div>
        </ModalBody>
      </ModalContent>
    </Modal>
  );
};

export default AccountSettingModal; 